module.exports = __webpack_public_path__ + "static/img/ver-4.1a9df676.png";